// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"modal-wrapper___lhzNP"};